var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThumbsUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 13,
  viewBox: "0 0 12 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7.5 0C8.345 0 9.269.695 9 1.501L7.5 4.547l3-.046c.846 0 1.5.794 1.5 1.5l-.964 5.003c-.165.827-.98 1.497-1.833 1.497H4.601c-.847 0-1.601-.68-1.601-1.533V4.5zM2 4.501v7.003c0 .55-.444.997-1 .997H0v-8z"
})));
export default SvgThumbsUp;